export class PipelineFilterConstants {

  static FILTER_NAMES = {
        NAME: "candidate_name",
        JOB_TITLE: "job_title",
        LOCATION: "location",
        COMPANY: "company",
        CONTACT_REQUESTED: 'contact_requested',
        CONTACT_STATUS: 'contact_status',
        SOURCE: 'source',
        STAGE: 'stage',
        TAGS: 'tags'
  };

    static PIPELINE_FILTER_MODAL = new Set([
        PipelineFilterConstants.FILTER_NAMES.JOB_TITLE,
        PipelineFilterConstants.FILTER_NAMES.NAME,
        PipelineFilterConstants.FILTER_NAMES.LOCATION,
        PipelineFilterConstants.FILTER_NAMES.COMPANY,
        PipelineFilterConstants.FILTER_NAMES.CONTACT_REQUESTED,
        PipelineFilterConstants.FILTER_NAMES.CONTACT_STATUS,
        PipelineFilterConstants.FILTER_NAMES.SOURCE,
        PipelineFilterConstants.FILTER_NAMES.STAGE,
        PipelineFilterConstants.FILTER_NAMES.TAGS
    ]);

    static MY_CANDIDATES_FILTER_MODAL = new Set([
        PipelineFilterConstants.FILTER_NAMES.JOB_TITLE,
        PipelineFilterConstants.FILTER_NAMES.NAME,
        PipelineFilterConstants.FILTER_NAMES.LOCATION,
        PipelineFilterConstants.FILTER_NAMES.COMPANY,
        PipelineFilterConstants.FILTER_NAMES.CONTACT_REQUESTED,
        PipelineFilterConstants.FILTER_NAMES.CONTACT_STATUS,
        PipelineFilterConstants.FILTER_NAMES.TAGS
    ]);


}
